import { doc } from "firebase/firestore"
import { firestore } from "../../../firebase/firebase"

const getNewsDocRef = (newsId) => {
  return doc(firestore, 'news', newsId);
}

export default getNewsDocRef;